import open_db from "./function/indexeddb/open-db";
import { db_loading } from "./function/indexeddb/index";
import get_db from "./function/indexeddb/get-db";
import set_db from "./function/indexeddb/set-db";
import destroy from "./function/indexeddb/destroy-db";
import db_request from "./function/indexeddb/db-request";

const worker_arr: any[] = [
  [open_db, "open_db"],
  [get_db, "get_db"],
  [set_db, "set_db"],
  [destroy, "destroy"],
  [db_request, "db_request"],
];

let blob_string: string =
  `const db_loading=${JSON.stringify(db_loading)};` +
  `${open_db.toString()};` +
  `${get_db.toString()};` +
  `${set_db.toString()};` +
  `${destroy.toString()};` +
  `(${db_request.toString()})()`;

worker_arr.forEach((worker_each: any) => (blob_string = blob_string.replace(new RegExp(worker_each[1], "g"), worker_each[0].name)));

export default class WebWorkerDB {
  postMessage: Function = (): void => {};
  addEventListener: Function = (): void => {};
  removeEventListener: Function = (): void => {};
  terminate: Function = (): void => {};

  constructor() {
    const blob = new Blob([`${blob_string}`], {
      type: "application/javascript",
    });
    return new Worker(URL.createObjectURL(blob));
  }
}
